import React from 'react';

const UniversityLocation = () => {
  return (
    <div className="university-location">
     
      <p style={{ marginLeft: '50px' }} >
        Our campus is located at:
      
        123 University Ave, Addis Ababa, Ethiopia
      </p>
      <div className="map-container">
         <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.649357418435!2d38.763732072054275!3d9.004375791055955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85a3b294c027%3A0x5c059416ab392b2a!2zQWRtYXMgVW5pdmVyc2l0eSBIZWFkIE9mZmljZSB8IERlbWJlbCB8IOGKoOGLteGIm-GItSDhi6nhipLhiajhiK3hiLXhibIg4YuL4YqTIOGImC_hiaThibUgfCDhi7DhiJ3hiaDhiI0!5e0!3m2!1sen!2set!4v1744794076394!5m2!1sen!2set" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" // <- Paste your actual embed URL here
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Admas University Meskel Campus Location"
  ></iframe>
      </div>
    </div>
  );
};

export default UniversityLocation;